import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';

const OnGeneralMessageDialog = ({ open, onClose, title = 'Oops! Ha sucedido un error', message = 'Algo salió mal. Intenta nuevamente.',buttonText = 'Registrar Factura', onRegister, buttonColor = 'primarybutton' }) => {
  return (
    <Dialog open={open} onClose={onClose}  maxWidth="lg">
      <DialogTitle textAlign={"left"}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant='subtitle'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancelar
        </Button>
        <Button onClick={onRegister} variant="contained" color={buttonColor} fontWeight={"bold"} sx={{fontWeight:"bold"}}>
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OnGeneralMessageDialog;
